/* selv-quick.js · Selv v6 · feuille d'ajout rapide (modèle du 7 oct. 2026 validé par la cliente, étendu le même jour à
   tous les produits à une seule variante, sauf le certificat-cadeau). Module (exécuté une seule fois par page).
   Le sac « + » d'une carte lq-card dont le formulaire porte data-sq ouvre une feuille au lieu d'ajouter tout de suite :
   choix du parfum (ou de la couleur) parmi la famille du produit, produit posé sur le fond lin, informations qui
   donnent envie (accroche, notes, contenu d'un coffret, durée, format, engagement), projection de livraison offerte,
   « Ajouter · Nordique » (« Ajouter au panier » pour un produit seul de sa famille).
   - Contenu : sections/selv-quick.liquid, demandé par l'API des sections (/products/<handle>?section_id=selv-quick),
     préchargé dès que le doigt ou la souris approche du bouton ; gardé en mémoire jusqu'au prochain changement du
     panier (la projection de livraison en dépend).
   - Ouverture immédiate : silhouette faite de la carte (titre, prix, image) pendant le chargement.
   - Prix : campagne de code (prix barré si html.lq-deal-on ou code au panier, sinon « … avec le code … »), prix de
     comparaison barré + « −25 % », « Gratuit ».
   - Ajout : /cart/add.js comme selv-card.js, puis les mêmes signaux (update:cart:drawer, cart:added : tiroir et île à
     jour), coche sur le bouton de la carte, goutte versée vers le panier et message « Ajouté à ton panier ».
   - Fermeture : croix, voile, Échap, glisser vers le bas (poignée ou en-tête) ; le focus revient au bouton de la carte.
   - Page panier et tiroir : jamais de feuille (ajout direct du lot PANIER).
   - Sans JS ou si le contenu ne vient pas : le formulaire de la carte garde son comportement (ajout direct). */
(() => {
  'use strict';
  if (window.SelvQuick) return;
  const d = document;
  const root = d.documentElement;
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const en = /^en/i.test(root.lang || '');
  const TXT = (() => {
    const t = {
      added: en ? 'Added to your cart' : 'Ajouté à ton panier',
      done: en ? 'Added' : 'Ajouté',
      addError: en ? 'Couldn’t add this item. Please try again in a moment.' : 'L’ajout n’a pas fonctionné. Réessaie dans un instant.',
      close: en ? 'Close' : 'Fermer',
    };
    try {
      const el = d.getElementById('SelvCartText');
      if (el && !en) {
        const j = JSON.parse(el.textContent);
        if (j.added) t.added = j.added;
        if (j.addError) t.addError = j.addError;
      }
    } catch (err) { /* textes par défaut */ }
    return t;
  })();
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const L = () => window.SelvLiquid || {};
  const toast = (msg, opts) => { const f = L().toast; if (typeof f === 'function') f(msg, opts || {}); };
  const bus = () => window.eventBus;

  /* ---------------------------------------------------------------- chargement */
  const cache = new Map();
  let cssWait = null;
  const loadCss = (href) => {
    if (cssWait) return cssWait;
    cssWait = new Promise((res) => {
      if (!href) { res(); return; }
      const l = d.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.onload = () => res();
      l.onerror = () => res();
      d.head.appendChild(l);
      setTimeout(res, 2500);
    });
    return cssWait;
  };
  const load = (handle) => {
    if (!cache.has(handle)) {
      const p = fetch(`${base}products/${encodeURIComponent(handle)}?section_id=selv-quick`, { headers: { Accept: 'text/html' } })
        .then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then((html) => {
          const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-sq]');
          if (!node) throw new Error('vide');
          return node;
        });
      p.catch(() => cache.delete(handle));
      cache.set(handle, p);
    }
    return cache.get(handle).then((node) => node.cloneNode(true));
  };
  const warmed = new WeakSet();
  const warm = (e) => {
    const form = e.target && e.target.closest ? e.target.closest('form.lq-card__quick[data-sq]') : null;
    if (!form || warmed.has(form)) return;
    warmed.add(form);
    loadCss(form.dataset.sqCss);
    load(form.dataset.sq).catch(() => {});
  };
  d.addEventListener('pointerover', warm, { passive: true });
  d.addEventListener('touchstart', warm, { passive: true });
  d.addEventListener('focusin', warm);
  const clear = () => cache.clear();
  const b0 = bus();
  if (b0 && typeof b0.on === 'function') {
    b0.on('cart:added', clear);
    b0.on('update:cart:drawer', clear);
  }
  window.addEventListener('pageshow', (e) => { if (e.persisted) clear(); });

  /* ---------------------------------------------------------------- feuille */
  let ui = null;
  let origin = null;
  let state = null;
  const shell = () => {
    if (ui) return ui;
    const wrap = d.createElement('div');
    wrap.className = 'sq-root';
    wrap.hidden = true;
    wrap.innerHTML = '<div class="sq-veil" data-sq-close></div><div class="sq-sheet" role="dialog" aria-modal="true" aria-labelledby="sq-title" tabindex="-1"><span class="sq-grab" aria-hidden="true"></span><div class="sq-slot"></div></div>';
    d.body.appendChild(wrap);
    const sheet = wrap.querySelector('.sq-sheet');
    const slot = wrap.querySelector('.sq-slot');
    wrap.addEventListener('click', (e) => {
      if (e.target.closest('[data-sq-close]')) { e.preventDefault(); close(); return; }
      const opt = e.target.closest('[data-sq-opt]');
      if (opt) { select(Number(opt.dataset.sqOpt), false); return; }
      if (e.target.closest('[data-sq-add]')) { e.preventDefault(); addCurrent(); }
    });
    wrap.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') { trap(e); return; }
      const opt = e.target.closest && e.target.closest('[data-sq-opt]');
      if (opt && state) {
        const n = state.opts.length;
        let i = Number(opt.dataset.sqOpt);
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') i = (i + 1) % n;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') i = (i - 1 + n) % n;
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = n - 1;
        else return;
        e.preventDefault();
        select(i, true);
      }
    });
    // glisser vers le bas pour fermer (poignée ou en-tête)
    let y0 = null;
    let dy = 0;
    sheet.addEventListener('pointerdown', (e) => {
      if (!e.target.closest('.sq-grab, .sq__head') || e.target.closest('button, a')) return;
      if (window.matchMedia('(min-width: 750px)').matches) return;
      y0 = e.clientY;
      dy = 0;
      sheet.setPointerCapture(e.pointerId);
      sheet.classList.add('is-drag');
    });
    sheet.addEventListener('pointermove', (e) => {
      if (y0 === null) return;
      dy = Math.max(0, e.clientY - y0);
      sheet.style.transform = `translateY(${dy}px)`;
    });
    const end = () => {
      if (y0 === null) return;
      y0 = null;
      sheet.classList.remove('is-drag');
      // fermeture : la feuille repart de là où le doigt l'a laissée (pas de retour en haut avant de descendre)
      if (dy > 90) { sheet.style.transform = 'translateY(104%)'; close(); } else sheet.style.transform = '';
    };
    sheet.addEventListener('pointerup', end);
    sheet.addEventListener('pointercancel', end);
    ui = { wrap, sheet, slot };
    return ui;
  };
  const focusables = () => Array.from(ui.sheet.querySelectorAll('button:not([disabled]):not([hidden]), a[href]:not([hidden]), [tabindex="0"]'))
    .filter((el) => el.offsetParent !== null || el === d.activeElement);
  const trap = (e) => {
    const f = focusables();
    if (!f.length) return;
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && (d.activeElement === first || d.activeElement === ui.sheet)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  const show = () => {
    const u = shell();
    clearTimeout(hideT);
    u.sheet.style.transform = '';
    u.wrap.hidden = false;
    root.classList.add('sq-lock');
    requestAnimationFrame(() => requestAnimationFrame(() => u.wrap.classList.add('is-open')));
  };
  let hideT = 0;
  const close = (after) => {
    if (!ui || ui.wrap.hidden) { if (after) after(); return; }
    ui.wrap.classList.remove('is-open');
    clearTimeout(hideT);
    hideT = setTimeout(() => {
      ui.wrap.hidden = true;
      ui.sheet.style.transform = '';
      ui.slot.textContent = '';
      root.classList.remove('sq-lock');
      state = null;
      if (origin && d.contains(origin)) { try { origin.focus({ preventScroll: true }); } catch (err) { origin.focus(); } }
      if (after) after();
    }, reduce ? 0 : 380);
  };

  // silhouette pendant le chargement : titre, prix et image de la carte
  const skeleton = (form) => {
    const card = form.closest('.lq-card');
    const title = card && card.querySelector('.lq-card__title');
    const price = card && card.querySelector('.lq-card__amount');
    const img = card && card.querySelector('.lq-card__img');
    const src = img ? (img.currentSrc || img.src || '') : '';
    return `<div class="sq sq--skel" aria-busy="true"><header class="sq__head"><div class="sq__ttl"><p class="sq__title" id="sq-title">${esc(title ? title.textContent.trim() : '')}</p><p class="sq__meta"><span class="sq__price">${esc(price ? price.textContent.trim() : '')}</span></p></div><button type="button" class="sq__x" data-sq-close aria-label="${TXT.close}"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg></button></header><div class="sq__body sq__body--solo"><div class="sq__aside"><div class="sq__photo">${src ? `<img class="sq__photo-img is-pack" src="${esc(src)}" alt="">` : ''}</div><div class="sq__info"><span class="sq__bar"></span><span class="sq__bar sq__bar--s"></span><span class="sq__bar"></span></div></div></div></div>`;
  };

  const select = (i, focus) => {
    if (!state || state.done || !state.panes[i]) return;
    state.i = i;
    state.opts.forEach((o, n) => {
      o.setAttribute('aria-checked', n === i ? 'true' : 'false');
      o.tabIndex = n === i ? 0 : -1;
    });
    state.panes.forEach((p, n) => { p.hidden = n !== i; });
    const p = state.panes[i];
    const q = (s) => state.node.querySelector(s);
    const title = q('[data-sq-title]');
    if (title) title.textContent = p.dataset.title || '';
    // prix : campagne de code (prix barré si le code est déjà appliqué, sinon « 21,75 $ avec le code … »),
    // sinon prix de comparaison du catalogue barré + pastille « −25 % », sinon le prix (« Gratuit » à 0 $)
    const ds = p.dataset;
    const sr = (t) => (t ? `<span class="lq-sr">${esc(t)} </span>` : '');
    const deal = ds.deal && (!Number(ds.ends) || Number(ds.ends) * 1000 > Date.now());
    const dealOn = deal && (ds.dealOn === '1' || root.classList.contains('lq-deal-on'));
    let html = esc(ds.price || '');
    if (dealOn) html = `<s>${sr(state.node.dataset.wasSr)}${esc(ds.price)}</s> <span class="sq__sale">${sr(state.node.dataset.nowSr)}${esc(ds.deal)}</span>`;
    else if (ds.was) html = `<s>${sr(state.node.dataset.wasSr)}${esc(ds.was)}</s> <span class="sq__sale">${sr(state.node.dataset.nowSr)}${esc(ds.price)}</span>${ds.save ? ` <span class="sq__save">${esc(ds.save)}</span>` : ''}`;
    const price = q('[data-sq-price]');
    if (price) price.innerHTML = html;
    const dealEl = q('[data-sq-deal]');
    if (dealEl) {
      dealEl.hidden = !(deal && !dealOn);
      dealEl.innerHTML = deal && !dealOn ? `<b>${esc(ds.deal)}</b> ${esc(state.node.dataset.with || '')} ${esc(ds.code || '')}` : '';
    }
    const rating = q('[data-sq-rating]');
    if (rating) rating.innerHTML = p.dataset.rating || '';
    const ship = q('[data-sq-ship]');
    if (ship) { ship.innerHTML = p.dataset.ship || ''; ship.hidden = !p.dataset.ship; }
    const label = q('[data-sq-label]');
    if (label) label.textContent = p.dataset.label || '';
    const addp = q('[data-sq-addp]');
    if (addp) addp.textContent = (dealOn ? ds.deal : ds.price) || '';
    const add = q('[data-sq-add]');
    const notify = q('[data-sq-notify]');
    const ok = p.dataset.available === 'true';
    if (add) { add.hidden = !ok; add.disabled = !ok; }
    if (notify) { notify.hidden = ok; notify.href = `${p.dataset.url || ''}#me-prevenir`; }
    if (state.opts.length > 1) {
      const live = q('[data-sq-live]');
      if (live && !state.first) live.textContent = (state.node.dataset.chosen || '[x]').replace('[x]', p.dataset.label || '');
    }
    state.first = false;
    if (focus && state.opts[i]) state.opts[i].focus();
  };

  const wire = (node) => {
    state = {
      node,
      opts: Array.from(node.querySelectorAll('[data-sq-opt]')),
      panes: Array.from(node.querySelectorAll('[data-sq-pane]')),
      i: Number(node.dataset.current || 0),
      first: true,
    };
    select(state.i, false);
  };

  /* ---------------------------------------------------------------- ajout */
  const post = (id) => {
    const data = new FormData();
    data.append('id', id);
    data.append('quantity', '1');
    data.append('sections', 'cart-drawer');
    return fetch(`${base}cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then((r) => r.json().catch(() => ({ status: r.status })).then((res) => {
        if (!r.ok || (res && res.status && res.status !== 200)) {
          const err = new Error((res && (res.description || res.message)) || '');
          err.res = res;
          throw err;
        }
        return res;
      }));
  };
  const added = (res, src) => {
    const b = bus();
    if (b && typeof b.emit === 'function') {
      b.emit('update:cart:drawer', res);
      b.emit('cart:added', res);
    }
    if (src && d.contains(src)) {
      src.classList.add('is-added');
      setTimeout(() => src.classList.remove('is-added'), 1600);
      const drop = L().drop;
      if (typeof drop === 'function') { try { drop(src); } catch (err) { /* animation facultative */ } }
    }
    toast(TXT.added);
  };
  const addCurrent = () => {
    if (!state) return;
    const p = state.panes[state.i];
    const btn = state.node.querySelector('[data-sq-add]');
    if (!p || !btn || state.done || p.dataset.available !== 'true' || btn.getAttribute('aria-busy') === 'true') return;
    const st = state;
    btn.setAttribute('aria-busy', 'true');
    post(p.dataset.id)
      .then((res) => {
        // ajouté : plus de second ajout ni de changement de parfum pendant la fermeture
        st.done = true;
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        const l = btn.querySelector('.sq__add-l');
        if (l) l.textContent = TXT.done;
        const pill = btn.querySelector('[data-sq-addp]');
        if (pill) pill.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
        setTimeout(() => close(() => added(res, origin)), reduce ? 0 : 420);
      })
      .catch((err) => {
        btn.removeAttribute('aria-busy');
        const live = st.node.querySelector('[data-sq-live]');
        const msg = (err && err.res && err.message) || TXT.addError;
        if (live) live.textContent = msg;
        toast(msg, { error: true, duration: 5200 });
      });
  };

  /* ---------------------------------------------------------------- ouverture */
  const open = (form, btn) => {
    origin = btn;
    const handle = form.dataset.sq;
    loadCss(form.dataset.sqCss).then(() => {
      const u = shell();
      u.slot.innerHTML = skeleton(form);
      show();
      u.sheet.focus({ preventScroll: true });
      load(handle)
        .then((node) => {
          if (u.wrap.hidden) return;
          u.slot.replaceChildren(node);
          wire(node);
          const f = node.querySelector('[aria-checked="true"]') || node.querySelector('[data-sq-add]');
          if (f) f.focus({ preventScroll: true });
        })
        .catch(() => {
          // contenu indisponible : ajout direct, comme avant la feuille
          close(() => {
            const id = form.querySelector('input[name="id"]');
            if (!id) return;
            post(id.value).then((res) => added(res, btn)).catch(() => toast(TXT.addError, { error: true, duration: 5200 }));
          });
        });
    });
  };
  // page panier et tiroir : le lot PANIER garde son ajout direct
  const SKIP = '[data-selv-cart-page], cart-drawer, #CartDrawer, .cart-drawer';
  const pick = (e) => (e.target && e.target.closest ? e.target.closest('form.lq-card__quick[data-sq] button') : null);
  // Phase de capture sur window : avant selv-card.js (capture sur document), qui ne voit alors rien.
  window.addEventListener('click', (e) => {
    const btn = pick(e);
    if (!btn) return;
    const form = btn.form || btn.closest('form');
    if (!form || form.closest(SKIP)) return;
    e.preventDefault();
    e.stopPropagation();
    open(form, btn);
  }, true);
  window.addEventListener('submit', (e) => {
    const form = e.target && e.target.closest ? e.target.closest('form.lq-card__quick[data-sq]') : null;
    if (!form || form.closest(SKIP)) return;
    e.preventDefault();
    e.stopPropagation();
    open(form, form.querySelector('button'));
  }, true);

  window.SelvQuick = { open, close };
})();
